import _ from 'underscore';
import {Map} from 'immutable';

import {myRemoveEntities, myRemoveEntitiesBySport} from './utils';

import {LIVE_INIT, LIVE_UPDATE} from 'sagas/actions';

import * as LiveActions from 'actions/Live';
import * as LineActions from 'actions/Line';
import * as StakeOfTheDayActions from 'actions/StakeOfTheDay';
import * as PopularActions from 'actions/Popular';

export default function (outcomes, action) {
    switch (action.type) {
        case LiveActions.CLEAR_LIVE:
        case LineActions.CLEAR_LINE:
            return Map();

        case LIVE_INIT.SUCCESS:
        case LineActions.SUCCESS_REQUEST_LINE_HEADERS:
        case LineActions.SUCCESS_REQUEST_SPORT_LINE_HEADERS:
        case LineActions.SUCCESS_REQUEST_LEAGUE_LINE_HEADERS:
        case StakeOfTheDayActions.SUCCESS_GET_STAKE_OF_THE_DAY:
        case PopularActions.SUCCESS_GET_POPULAR_MATCHES:
            return init(Map(), action.data);

        case LineActions.SUCCESS_REQUEST_FULL_LINE: {
            const matches = _.map(action.data.events.add, (m) => {
                return {id: m.id}
            });
            //outcomes = removeEntities(outcomes, 'matchId', matches);
            outcomes = myRemoveEntities(outcomes, 'matchId', matches);
            return init(outcomes, action.data);
        }

        case LIVE_UPDATE.SUCCESS:
            return update(outcomes, action.data);
    }

    return outcomes;
}

function init(outcomes, data) {
    if (data.outcomes !== undefined) {
        outcomes = addOutcomes(outcomes, data.outcomes.add);
    }

    if (data.blocked_outcomes !== undefined) {
        outcomes = addBlockedOutcomes(outcomes, data.blocked_outcomes.add);
    }

    if (data.rates !== undefined) {
        outcomes = addOutcomeRates(outcomes, data.rates.add);
    }

    return outcomes;
}

function update(outcomes, data) {

    if (data.sports !== undefined && data.sports.remove !== undefined) {
        //outcomes = removeEntities(outcomes, 'sportId', data.sports.remove);
        outcomes = myRemoveEntitiesBySport(outcomes, 'sportId', data.sports.remove);
    }

    if (data.leagues !== undefined && data.leagues.remove !== undefined) {
        //outcomes = removeEntities(outcomes, 'leagueId', data.leagues.remove);
        outcomes = myRemoveEntities(outcomes, 'leagueId', data.leagues.remove);
    }

    if (data.events !== undefined && data.events.remove !== undefined) {
        //outcomes = removeEntities(outcomes, 'matchId', data.events.remove);
        outcomes = myRemoveEntities(outcomes, 'matchId', data.events.remove);
    }

    if (data.blocked_outcomes !== undefined) {
        outcomes = removeBlockedOutcomes(outcomes, data.blocked_outcomes.remove);
    }

    if (data.outcomes !== undefined) {
        //outcomes = removeEntities(outcomes, 'id', data.outcomes.remove);
        outcomes = myRemoveEntities(outcomes, 'id', data.outcomes.remove);
        outcomes = addOutcomes(outcomes, data.outcomes.add);
        outcomes = updateOutcomes(outcomes, data.outcomes.change);
    }

    if (data.blocked_outcomes !== undefined) {
        outcomes = addBlockedOutcomes(outcomes, data.blocked_outcomes.add);
    }

    if (data.rates !== undefined) {
        outcomes = addOutcomeRates(outcomes, data.rates.add);
    }

    return outcomes;
}

function addOutcomes(outcomes, addOutcomes) {
    if (addOutcomes === undefined) {
        return outcomes;
    }

    outcomes = outcomes.withMutations(o => {
        for (let i = 0; i < addOutcomes.length; i++) {
            const addedOutcome = addOutcomes[i];
            if (addedOutcome === undefined || addedOutcome.matchId === undefined) {
                throw new Error('Add outcome: parent key not found');
            }

            const plainOutcome = {
                ...addedOutcome,
                rates: Map(),
                isBlocked: false,
                //isHeader: false
            };

            const outcome = Map(plainOutcome);

            o.set(addedOutcome.id, outcome);
        }
    });

    return outcomes;
}

function updateOutcomes(outcomes, changeOutcomes) {
    if (changeOutcomes === undefined) {
        return outcomes;
    }

    for (let i = 0; i < changeOutcomes.length; i++) {
        const changeOutcome = changeOutcomes[i];

        const outcome = outcomes.get(changeOutcome.id);
        if (outcome) {
            ((outcomeId, isHeader, groupId) => {
                outcomes = outcomes.update(outcomeId, (o) => {
                    return o.set('isHeader', isHeader).set('groupId', groupId);
                });
            })(changeOutcome.id, changeOutcome.ih || false, parseInt(`${changeOutcome.e}${changeOutcome.g || 0}`));
        }
    }

    return outcomes;
}

function addOutcomeRates(outcomes, addRates) {
    if (addRates === undefined) {
        return outcomes;
    }

    for (let i = 0; i < addRates.length; i++) {
        (function (rate) {
            const outcomeId = rate.outcomeId;
            const rateId = rate.id;
            const rateType = rate.type;

            outcomes = outcomes.setIn([outcomeId, 'rates', rateType], rateId);
        })(addRates[i]);
    }

    return outcomes;
}

function addBlockedOutcomes(outcomes, addBlockedOutcomes) {
    if (addBlockedOutcomes === undefined) {
        return outcomes;
    }

    for (let i = 0; i < addBlockedOutcomes.length; i++) {
        const outcomeId = addBlockedOutcomes[i];

        (outcomeId => {
            outcomes = outcomes.setIn([outcomeId, 'isBlocked'], true);
        })(outcomeId);
    }

    return outcomes;
}

function removeBlockedOutcomes(outcomes, removeBlockedOutcomes) {
    if (removeBlockedOutcomes === undefined) {
        return outcomes;
    }

    for (let i = 0; i < removeBlockedOutcomes.length; i++) {
        const outcomeId = removeBlockedOutcomes[i];

        (outcomeId => {
            outcomes = outcomes.setIn([outcomeId, 'isBlocked'], false);
        })(outcomeId);
    }

    return outcomes;
}



// WEBPACK FOOTER //
// ./js/shared/reducers/entities/outcomesReducer.js